import { NgModule } from '@angular/core';
import { Ng2FilterPipe } from './_Pipes/ng2-filter.pipe';

@NgModule({
  declarations: [Ng2FilterPipe],
  exports: [Ng2FilterPipe]
})
export class Ng2SearchFilterModule {}
